"use client";

import {
  BaseQueryApi,
  FetchArgs,
  createApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import { RootState, store } from "../store";
import { STRINGS } from "../utils/strings";
import { logoutUser } from "./features/userSlice";

export const baseQuery = fetchBaseQuery({
  baseUrl: STRINGS.API_URL,
  prepareHeaders(headers, api) {
    const state = api.getState() as RootState;

    // Access the token directly from `state.user`
    const token = state.user?.access_token;
    console.log("Fetched Token:", token);

    if (token) {
      headers.set("authorization", `Bearer ${token}`);
      console.log("Authorization Header Set:", `Bearer ${token}`);
    } else {
      console.warn("No token found. Authorization header not set.");
    }

    return headers;
  },
});

export const baseQueryWithReauth = async (
  args: string | FetchArgs,
  api: BaseQueryApi,
  extraOptions: {}
) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    console.warn("401 Unauthorized — logging user out.");
    store.dispatch(logoutUser());
  }

  return result;
};

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Me"],
  refetchOnMountOrArgChange: true,
  endpoints: () => ({}),
});

export enum methods {
  GET = "GET",
  POST = "POST",
  PATCH = "PATCH",
  PUT = "PUT",
  DELETE = "DELETE",
}

export type DefaultResponse<T> = {
  code: number;
  message: string;
  data: T;
};
